// src/axiosConfig.ts
import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';

// Configuración de las distintas instancias de Axios usando variables de entorno
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

const apiVentas = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

const apiProductos = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

// Función para agregar interceptores a cada instancia de Axios
const applyInterceptors = (instance: any) => {
  instance.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers = config.headers || {};
        config.headers['x-auth-token'] = token;
      }
      return config;
    },
    (error: AxiosError) => Promise.reject(error)
  );

  // src/axiosConfig.ts
  instance.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => {
      if (error.response?.status === 401 && !error.config?.url?.includes('/api/auth/user')) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  );
};

applyInterceptors(api);
applyInterceptors(apiVentas);
applyInterceptors(apiProductos);

export { api, apiVentas, apiProductos };
